import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Injectable, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { GenericHttpClient } from '../Services/Basicauthentication';
import { serviceUrl } from '../common/serviceconstants';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmitterService } from '../emitterservice';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ProjectdocmodelpopupComponent } from '../projectdocmodelpopup/projectdocmodelpopup.component';

@Component({
  selector: 'app-projectlist',
  templateUrl: './projectlist.component.html',
  styleUrls: ['./projectlist.component.scss']
})
@Injectable({
  providedIn: 'root'
})

export class ProjectlistComponent implements OnInit, AfterViewInit {
  element: any = [];
  formControl: AbstractControl;
  FiscalYear = "";
  ProjectNumber = "";
  ProjectName = "";
  ProjectCategory: "";
  ProjectSubCategory: "";
  ProjectStatus: "";
  CIPBudgetAmount: "";
  Actuals: "";
  AmountEncumbered: "";
  RemainingBalance: "";
  PublishedProject: "";
  isadmin: any = false;

  dialogRef: MatDialogRef<ProjectdocmodelpopupComponent> | null;
  config = {
    disableClose: false,
    panelClass: 'custom-overlay-pane-class',
    hasBackdrop: true,
    backdropClass: '',
    width: '980px',
    height: '450px',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    },
    data: {
      message: 0
    }
  };
  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private httpClient: GenericHttpClient,
    private http: HttpClient,
    private dialog: MatDialog) {
    let a = sessionStorage.getItem("Admin");
    if (a && a === "True") {
      this.isadmin = true;
    }
    this.getProjectList();
  }

  dataSource = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  FilterSource() {
    this.dataSource.filterPredicate = ((data, filter) => {
      const a = !filter.FiscalYear || String(data.FiscalYear).includes(filter.FiscalYear)
      const b = !filter.ProjectName || data.ProjectName.toLowerCase().includes(filter.ProjectName.toLowerCase());
      const c = !filter.ProjectNumber || data.ProjectNumber.toLowerCase().includes(filter.ProjectNumber.toLowerCase());
      const d = !filter.ProjectCategory || data.ProjectCategory.toLowerCase().includes(filter.ProjectCategory.toLowerCase());
      const e = !filter.ProjectSubCategory || data.ProjectSubCategory.toLowerCase().includes(filter.ProjectSubCategory.toLowerCase());
      const f = !filter.ProjectStatus || data.ProjectStatus.toLowerCase().includes(filter.ProjectStatus.toLowerCase());
      const g = !filter.CIPBudgetAmount || ("$" + this.addCommas(data.CIPBudgetAmount)).toLowerCase().includes(filter.CIPBudgetAmount.toLowerCase());
      const h = !filter.Actuals || ("$" + this.addCommas(data.Actuals)).toLowerCase().includes(filter.Actuals.toLowerCase());
      const i = !filter.AmountEncumbered || ("$" + this.addCommas(data.AmountEncumbered)).toLowerCase().includes(filter.AmountEncumbered.toLowerCase());
      const j = !filter.RemainingBalance || ("$" + this.addCommas(data.RemainingBalance)).toLowerCase().includes(filter.RemainingBalance.toLowerCase());
      const k = !filter.PublishedProject || (filter.PublishedProject && (data.PublishedProject ? "yes".includes(filter.PublishedProject.toLowerCase()) : "no".includes(filter.PublishedProject.toLowerCase())));

      return a && b && c && d && e && f && g && h && i && j && k;
      // return a && b && c;
    }) as (PeriodicElement, string) => boolean;

    this.formControl = this.formBuilder.group({
      FiscalYear: '',
      ProjectNumber: '',
      ProjectName: '',
      ProjectCategory: '',
      ProjectSubCategory: '',
      ProjectStatus: '',
      CIPBudgetAmount: '',
      Actuals: '',
      AmountEncumbered: '',
      RemainingBalance: '',
      PublishedProject: ''
    });

    this.formControl.valueChanges.subscribe(value => {
      if (value.Status === "All")
        value.Status = '';
      const filter = { ...value, name: value.ID } as string;
      this.dataSource.filter = filter;
    });


  }

  displayedColumns: string[] = [];


  ngOnInit() {
    if (this.isadmin) {
      this.displayedColumns = [
        'Select',
        'FiscalYear',
        'ProjectNumber',
        'ProjectName',
        //'ProjectCategory',
        'ProjectSubCategory',
        'ProjectStatus',
        'CIPBudgetAmount',
        // 'Actuals',
        // 'AmountEncumbered',
        // 'RemainingBalance',
        'Published',
        'View',
        'Update',
        'Delete'

      ];
    } else {
      this.displayedColumns = [

        'FiscalYear',
        'ProjectNumber',
        'ProjectName',
        // 'ProjectCategory',
        'ProjectSubCategory',
        'ProjectStatus',
        'CIPBudgetAmount',
        //'Actuals',
        //'AmountEncumbered',
        //'RemainingBalance',
        'View'

      ];
    }
    this.FilterSource();


  }

  ViewProjectDocsinfo(item) {
    this.config.data.message = item;
    this.dialogRef = this.dialog.open(ProjectdocmodelpopupComponent, this.config)
  }

  GoToProjectManagement() {
    this.router.navigateByUrl('/Projectdetails');

  }


  SaveProjectInfo(item, ispublish) {

    const hdrs = new HttpHeaders(
      { 'Content-type': 'application/json' });
    this.http.post<any>(serviceUrl + '/Project/InsertProjectInfo', {
      FiscalYear: item.FiscalYear,
      ProjectNumber: item.ProjectNumber,
      ProjectName: item.ProjectName,
      ProjectCategory: item.ProjectCategory,
      ProjectSubCategory: item.ProjectSubCategory,
      ProjectStatus: item.ProjectStatus,
      CIPBudgetAmount: item.CIPBudgetAmount,
      Actuals: item.Actuals,
      AmountEncumbered: item.AmountEncumbered,
      RemainingBalance: item.RemainingBalance,
      Comments: item.Comments,
      ID: item.ID,
      ModifiedBy: item.ModifiedBy,
      PublishedProject: ispublish
    }, { headers: hdrs }).subscribe(
      res => {
        // this.ClearProjectInfo();

        this.getProjectList();
        // if (res !== 0)
        //   this.id = res;
        // this.pmessage = 'Project Successfully saved.';

      },
      err => {


      });

  }
  selectedItems = [];

  Publishdata() {
    if (confirm('Are you sure want to publish selected Project/Projects?')) {
      this.selectedItems = this.selection.selected;
      let i = 1;

      this.selectedItems.forEach(row => {
        //this.SaveProjectInfo(row, false);
        //this.selection.clear();
        row.PublishedProject = true;
        //i++;
      })
      const hdrs = new HttpHeaders(
        { 'Content-type': 'application/json' });
      this.http.post<any>(serviceUrl + '/Project/PublishProjectInfo', {
        projs: this.selectedItems
      }, { headers: hdrs }).subscribe(
        res => {

          EmitterService.get('publish').emit(true);
          this.selection.clear();

        },
        err => {


        });

      //console.log(this.selectedItems);
      // this.selectedItems.forEach(row => {
      //   this.SaveProjectInfo(row, true);
      //   this.selection.clear();
      //   if (this.selectedItems.length === i) {
      //     EmitterService.get('publish').emit(true);
      //   }
      //   i++;
      //   //EmitterService.get('publish').emit(true);
      // })
    }

  }

  UnPublishdata() {
    if (confirm('Are you sure want to unpublish selected Project/Projects?')) {
      this.selectedItems = this.selection.selected;
      //console.log(this.selectedItems);
      let i = 1;
      this.selectedItems.forEach(row => {
        //this.SaveProjectInfo(row, false);
        //this.selection.clear();
        row.PublishedProject = false;
        //i++;
      })
      const hdrs = new HttpHeaders(
        { 'Content-type': 'application/json' });
      this.http.post<any>(serviceUrl + '/Project/PublishProjectInfo', {
        projs: this.selectedItems
      }, { headers: hdrs }).subscribe(
        res => {

          EmitterService.get('publish').emit(true);
          this.selection.clear();

        },
        err => {


        });

      //   this.selectedItems.forEach(row => {
      //     this.SaveProjectInfo(row, false);
      //     this.selection.clear();
      //     if (this.selectedItems.length === i) {
      //       EmitterService.get('publish').emit(true);
      //     }
      //     i++;
      //   })
    }
  }


  updateprojectinfo(item) {
    sessionStorage.setItem('projinfo', JSON.stringify(item));
    this.router.navigateByUrl('/Projectdetails');
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
  addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;

  }
  isAllSelected() {

    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected === numRows;
  }


  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.filteredData.forEach(row => this.selection.select(row));
  }

  projectmessage: any = '';

  getProjectList() {
    this.httpClient.get(serviceUrl + '/Project/GetAllProjectsList', { isadmin: this.isadmin }
    ).toPromise<any>().then(response => {
      //this.dataSource = new MatTableDataSource(response);
      if (response.length > 0) {
        this.dataSource.data = response;
      } else {
        this.projectmessage = "No Projects at this time. Please try again later."
      }
    });
  }


  DeleteProjectInfo(row) {
    const index = -1;
    if (confirm('Do you want to delete selected Project?')) {
      // console.log("OK!");
      const hdrs = new HttpHeaders(
        { 'Content-type': 'application/json' });
      this.http.post<any>(serviceUrl + '/Project/DeleteProjectInfo', {
        ID: row.ID
      }, { headers: hdrs }).subscribe(
        res => {
          this.getProjectList();
          EmitterService.get('delete').emit(true);
        },
        err => {

        });

    } else {
    }

  }
}